import { Outlet } from "react-router-dom";
import LayoutContainer from "./LayoutContainer";

const RouteLayout = () => {
  return (
    <LayoutContainer>
      <Outlet />
    </LayoutContainer>
  );
};

export default RouteLayout;
